// eslint-disable-next-line strict-dependencies/strict-dependencies
import type { CSSObject } from "@emotion/react";

export const pointingDevice = (styles: CSSObject): CSSObject => ({
  "@media (hover: hover) and (pointer: fine)": styles,
});
